export enum LocalStorageKeyName {
    GameId = 'ind3x-shiritori-game-id',
    Language = 'ind3x-shiritori-lang-code',
    Theme = 'ind3x-shiritori-theme',
    DeviceId = 'ind3x-shiritori-device-id',
    PlayerName = 'ind3x-shiritori-player-name',
}

export function SetLocalStorage(key: LocalStorageKeyName, value: string) {
    localStorage.setItem(key, value);
}

export function GetLocalStorage(key: LocalStorageKeyName) {
    return localStorage.getItem(key);
}

export function RemoveLocalStorage(key: LocalStorageKeyName) {
    localStorage.removeItem(key);
}
